import React from "react";
import "./HimalyanDiamond.css"; // Import your CSS for styling
import prodImg from "../../assets/PackageImages/Kuber(Green).png";
import { projects } from "../../data/projectsData";
import {
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NutritionalTable from "./NutritionalTable";
import { useMediaQuery, useTheme } from "@mui/material";

const KuberMix = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const otherProducts = Object.values(projects).flatMap((group, index) =>
    group.map((item) => {
      return { ...item, group: `${index + 1}` };
    })
  );

  const tableData = [
    {
      nutrient: "Protein",
      value: "22%",
      comment: "Supports high milk production and muscle development.",
    },
    {
      nutrient: "Fat",
      value: "4%",
      comment: "Provides a steady source of energy to sustain milk yield.",
    },
    {
      nutrient: "Fiber",
      value: "10 - 12%",
      comment: "Aids in digestion and ensures a healthy gut.",
    },
    {
      nutrient: "Moisture",
      value: "5%",
      comment: "Maintains freshness and palatability of the feed.",
    },
  ];

  return (
    <div className="product-container">
      <div className="product-details">
        <div
          className={
            isMobile ? "product-image product-image--mobile" : "product-image"
          }
        >
          <img
            src={prodImg} // Replace with the actual image path
            alt="Himalaya Diamond Premium"
          />
        </div>
        <div className="product-info">
          <div>
            <div className="product-title">KUBER MIX </div>

            <div
              style={{
                textAlign: "justify",
              }}
            >
              <p className="bold-description-line">
                <b>
                  Kuber Mix – Coarsely Ground Premium Cattle Feed for High-Milk
                  Yielding Cows
                </b>
              </p>
              <p>
                Kuber Mix is a specially formulated, coarsely ground cattle feed
                designed to support the health and productivity of dairy cattle
                producing between 15 to 25 liters of milk per day.
              </p>
              <p>
                This balanced feed is packed with high-quality ingredients such
                as de-oiled rice bran, rice bran, soybean, guar, cottonseed,
                cottonseed cake, crushed moong, vitamins, minerals, jaggery, and
                other nutrient-rich crushed grains, providing optimal nutrition
                for high-yielding dairy cows.
              </p>
              <p>
                Kuber Mix is the ideal feed solution for farmers looking to
                optimize the milk production and health of their high-yielding
                dairy cows, ensuring a longer, productive lactation cycle while
                keeping cows healthy and strong.
              </p>
            </div>
          </div>
          <div>
            <h3 className="benefits-title">KEY BENEFITS:</h3>
            <ul>
              <li className="benefit">
                <div>
                  <b>Supports High Milk Yield: </b>
                  Kuber Mix is rich in protein and energy, ensuring that your
                  cows maintain high levels of milk production consistently,
                  making it ideal for cows producing 15 to 25 liters of milk
                  daily.
                </div>
              </li>

              <li className="benefit">
                <div>
                  <b>Promotes Long Lactation Periods: </b>
                  Designed to enhance the overall health and stamina of dairy
                  cattle, Kuber Mix supports lactation periods of 300 days or
                  more, maximizing milk output and the productivity of your
                  herd.
                </div>
              </li>

              <li className="benefit">
                <div>
                  <b>Enhanced Digestive Health: </b>
                  The fiber content, combined with crushed grains and
                  ingredients like guar and crushed moong, promotes healthy
                  digestion, ensuring better nutrient absorption and preventing
                  digestive issues in cattle.
                </div>
              </li>

              <li className="benefit">
                <div>
                  <b>Energy Boost for Lactating Cows: </b>
                  The inclusion of jaggery provides a quick energy boost, which
                  is essential for cows that are producing high volumes of milk
                  and require sustained energy levels.
                </div>
              </li>

              <li className="benefit">
                <div>
                  <b>Complete Nutritional Support: </b>
                  With added vitamins and minerals, Kuber Mix not only supports
                  milk production but also enhances the overall health of the
                  cow, promoting stronger immunity and better reproductive
                  health.
                </div>
              </li>
            </ul>
          </div>
          <div>
            <NutritionalTable data={tableData} />
          </div>
        </div>
      </div>

      <div className="other-products">
        <Typography variant="h6" gutterBottom>
          Products Catalogue
        </Typography>
        <List>
          {otherProducts.map((product) => {
            return (
              <ListItem
                key={product.id}
                component={Link}
                to={`/products/${product.id}`}
                style={{
                  borderBottom: "1px lightgray dotted",
                  color: "black",
                  ...(product.id === "Kuber-mix" && {
                    backgroundColor: "#4caf50",
                    color: "white",
                    borderRadius: "1rem",
                  }),
                }}
              >
                <ListItemIcon
                  style={{
                    minWidth: "0px",
                  }}
                >
                  <ArrowForwardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  primary={product.title}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </div>
  );
};

export default KuberMix;
